import axios from "axios";
import { useEffect, useState } from "react";
import { api } from "../api/api";

export default function useFetch(url, options = {}) {
  const { run = true } = options;
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [refetcher, setRefetcher] = useState(false);

  useEffect(() => {
    if (!run || !url) return;

    const source = axios.CancelToken.source();
    const fetchData = async () => {
      try {
        setLoading(true);
        setData(undefined);
        const res = await api.get(url, { cancelToken: source.token });
        res.data && setData(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    return () => {
      source.cancel();
    };
  }, [url, refetcher, run]);

  const refetch = () => {
    setRefetcher((v) => !v);
  };

  return { data, loading, refetch };
}
